export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const DONE_FETCHING_CAMPAIGNS = 'DONE_FETCHING_CAMPAIGNS';
export const ERROR_FETCHING_CAMPAIGNS = 'ERROR_FETCHING_CAMPAIGNS';

export const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
export const DONE_FETCHING_CAMPAIGN = 'DONE_FETCHING_CAMPAIGN';
export const ERROR_FETCHING_CAMPAIGN = 'ERROR_FETCHING_CAMPAIGN';

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const DONE_CREATING_CAMPAIGN = 'DONE_CREATING_CAMPAIGN';
export const ERROR_CREATING_CAMPAIGN = 'ERROR_CREATING_CAMPAIGN';
export const SET_CAMPAIGN_IN_CREATION_USECASE = 'SET_CAMPAIGN_IN_CREATION_USECASE';

// export const UPDATE_CONTENT_ATTRIBUTES = 'UPDATE_CONTENT_ATTRIBUTES';
// export const DONE_UPDATING_CONTENT_ATTRIBUTES = 'DONE_UPDATING_CONTENT_ATTRIBUTES';
// export const ERROR_UPDATING_CONTENT_ATTRIBUTES = 'ERROR_UPDATING_CONTENT_ATTRIBUTES';

export const UPDATE_SAMPLE_MESSAGES = 'UPDATE_SAMPLE_MESSAGES';
export const DONE_UPDATING_SAMPLE_MESSAGES = 'DONE_UPDATING_SAMPLE_MESSAGES';
export const ERROR_UPDATING_SAMPLE_MESSAGES = 'ERROR_UPDATING_SAMPLE_MESSAGES';

export const UPDATE_AUTO_RENEWAL = 'UPDATE_AUTO_RENEWAL';
export const DONE_UPDATING_AUTO_RENEWAL = 'DONE_UPDATING_AUTO_RENEWAL';
export const ERROR_UPDATING_AUTO_RENEWAL = 'ERROR_UPDATING_AUTO_RENEWAL';

export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DONE_DELETING_CAMPAIGN = 'DONE_DELETING_CAMPAIGN';
export const ERROR_DELETING_CAMPAIGN = 'ERROR_DELETING_CAMPAIGN';

export const QUALIFY_BRAND = 'QUALIFY_BRAND';
export const DONE_QUALIFYING_BRAND = 'DONE_QUALIFYING_BRAND';
export const ERROR_QUALIFYING_BRAND = 'ERROR_QUALIFYING_BRAND';

export const REMOVE_CREATION_ERRORS = 'REMOVE_CREATION_ERRORS';
export const REMOVE_UPDATE_ERRORS = 'REMOVE_UPDATE_ERRORS';
export const REMOVE_LAST_CREATED_CAMPAIGN = 'REMOVE_LAST_CREATED_CAMPAIGN';
export const RESET_FORM = 'RESET_FORM';
export const REMOVE_LAST_DELETED_CAMPAIGN = 'REMOVE_LAST_DELETED_CAMPAIGN';
export const REMOVE_DELETION_ERROR = 'REMOVE_DELETION_ERROR';

export const HANDLE_NUMBER_LINK = 'HANDLE_NUMBER_LINK';
export const DONE_HANDLING_NUMBER_LINK = 'DONE_HANDLING_NUMBER_LINK';
export const DONE_HANDLING_NUMBER_UNLINK = 'DONE_HANDLING_NUMBER_UNLINK';
export const ERROR_HANDLING_NUMBER_LINK = 'ERROR_HANDLING_NUMBER_LINK';
export const CLEAR_NUMBERS = 'CLEAR_NUMBERS';
export const CLEAR_ERROR_HANDLING_NUMBERS = 'CLEAR_ERROR_HANDLING_NUMBERS';
export const ADD_LINKED_CAMPAIGN = 'ADD_LINKED_CAMPAIGN';
